import { createFileRoute, redirect } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { ensureEstatesQueryData } from '@/features/estates/api/estates';

export const Route = createFileRoute('/_authenticated/_sidebar-layout/')({
  validateSearch: zodValidator(
    z.object({
      view: fallback(z.enum(['grid', 'list', 'map']).optional(), 'list'),
      search: fallback(z.string().optional(), ''),
      enableFilters: fallback(z.boolean().optional(), false),
    })
  ),
  // Estates is the start page; the old dashboard is no longer in the menu
  beforeLoad: () => {
    throw redirect({ to: '/estates', replace: true });
  },
  loader: ensureEstatesQueryData,
});
